"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneMutedSmallOutlineNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneMutedSmallOutlineNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.853 8.025a7.854 7.854 0 0 1-.747-1.387.654.654 0 0 1 .15-.707l.919-.918a1.75 1.75 0 0 0 .512-1.238V2.75A1.75 1.75 0 0 0 4.937 1H3.625A2.625 2.625 0 0 0 1 3.625c0 2.6.873 4.997 2.34 6.913l.719-.718A10.319 10.319 0 0 1 2 3.625C2 2.73 2.73 2 3.625 2h1.312c.414 0 .75.337.75.75v1.025c0 .2-.078.389-.22.53l-.917.919a1.646 1.646 0 0 0-.367 1.797c.253.61.574 1.187.954 1.721l.716-.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.368.368 0 0 0 .007-.008l.7-.7a.5.5 0 0 1 .707.708L7.177 9.53a7.873 7.873 0 0 0 2.185 1.364.615.615 0 0 0 .237.046.67.67 0 0 0 .47-.197l.918-.918a1.749 1.749 0 0 1 1.237-.512h1.026c.966 0 1.75.783 1.75 1.75v1.312A2.635 2.635 0 0 1 12.36 15h-.005a11.334 11.334 0 0 1-7.662-2.986l-3.84 3.84a.5.5 0 0 1-.714-.7Zm6.332-4.919-1.067 1.067A10.334 10.334 0 0 0 12.357 14c.907 0 1.643-.729 1.643-1.625v-1.312a.75.75 0 0 0-.75-.75h-1.025c-.198 0-.39.08-.53.219l-.918.918c-.312.312-.741.49-1.178.49a1.61 1.61 0 0 1-.62-.122 8.862 8.862 0 0 1-2.507-1.583Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneMutedSmallOutlineNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneMutedSmallOutlineNo;
exports["default"] = _default;